import {axios} from '../../services/axios';

export default async function deleteApprovalCode(approvalCodeId) {
    return axios
        .delete(`/ApprovalCode/${approvalCodeId}`)
        .then((res) => res)
        .catch((e) => e);
}
